<div
  class="w-full min-h-full flex flex-col justify-start items-center text-center"
  #container
>
  <mat-vertical-stepper
    [orientation]="stepperOrientation"
    [linear]="true"
    #stepper
  >
    <mat-step>
      <div class="flex flex-col justify-center items-center">
        @if (deliveryId != null) {
          <p class="my-3">
            By signing you acknowledge that the equipment has been received and
            is in good condition and working order, and you have read and agree
            to abide by the terms & conditions.
          </p>
        } @else {
          <p class="my-3">
            By signing you are indicating you have read and agree to abide by
            the terms & conditions
          </p>
        }
        <button
          color="primary"
          class="mb-3 !max-h-auto flex-shrink-0"
          mat-flat-button
          (click)="openTermsDialog()"
        >
          <p class="py-2">Terms & Conditions</p>
        </button>
      </div>

      <div class="flex flex-row justify-end items-center mt-12">
        <button mat-button matStepperNext>Next</button>
      </div>
    </mat-step>

    <mat-step [stepControl]="printName">
      <ng-template matStepLabel>Print name</ng-template>
      <div class="flex flex-col w-full justify-center items-stretch">
        <p class="text-center">Please Enter your full name:</p>
        <mat-form-field>
          <mat-label>Print Name</mat-label>
          <input
            matInput
            placeholder="Print Name"
            autofocus
            [formControl]="printName"
            class="capitalize w-full"
            required
          />
        </mat-form-field>
      </div>

      <div class="flex flex-row justify-end items-center mt-12">
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button matStepperNext>Next</button>
      </div>
    </mat-step>
    <mat-step [stepControl]="drawn">
      <ng-template matStepLabel>Sign</ng-template>
      <p class="landscape:hidden md:hidden py-4">
        Please rotate the screen so it is in landscape mode.
      </p>
      <div
        class="w-full overflow-x-auto portrait:hidden md:flex landscape:flex flex-col"
      >
        <p>Draw your signature in the box below:</p>
        <signature-pad
          #signature
          [options]="signaturePadOptions"
          (drawStart)="drawStart($event)"
          (drawEnd)="drawComplete($event)"
        ></signature-pad>
      </div>

      <div class="flex flex-row justify-end items-center mt-2">
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button matStepperNext>Next</button>
      </div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Confirm</ng-template>
      <div class="flex flex-col justify-start items-center space-y-4">
        <p>
          Thanks, please hand the device back to the staff member to confirm
          these details
        </p>
        <app-key-value-pair
          name="Print name"
          [value]="printName.value"
        ></app-key-value-pair>
        <img
          [src]="imageData"
          class="max-h-16 w-auto self-center"
          alt="Signature image data"
        />
        <div class="flex flex-row justify-end items-center mt-12">
          <button mat-button (click)="saveAndClose()">Save</button>
        </div>
      </div>
    </mat-step>
  </mat-vertical-stepper>
</div>
